///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class UserAuthorities {
    public static readonly SIKLU_ADMIN = 'ROLE_SIKLU_ADMIN';
    public static readonly SIKLU_CUSTOMER_SUPPORT = 'ROLE_SIKLU_CUSTOMER_SUPPORT';
    public static readonly SIKLU_SALES = 'ROLE_SIKLU_SALES';
    public static readonly SIKLU_ACCOUNTANT = 'ROLE_SIKLU_ACCOUNTANT';
    public static readonly COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN';
    public static readonly COMPANY_PLANNER = 'ROLE_COMPANY_PLANNER';
    public static readonly COMPANY_USER = 'ROLE_COMPANY_USER';
    public static readonly ANY_USER = 'ROLE_ANY_USER';
    public static readonly ANONYMOUS = 'ROLE_ANONYMOUS';
    public static readonly NO_ONE = 'ROLE_NO_ONE';

    public static readonly ALL = [
        UserAuthorities.SIKLU_ADMIN,
        UserAuthorities.SIKLU_ACCOUNTANT,
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.SIKLU_SALES,
        UserAuthorities.COMPANY_ADMIN,
        UserAuthorities.COMPANY_PLANNER,
        UserAuthorities.COMPANY_USER
    ];
    public static readonly ALL_SIKLU = [
        UserAuthorities.SIKLU_ADMIN,
        UserAuthorities.SIKLU_ACCOUNTANT,
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.SIKLU_SALES
    ];
    public static readonly SIKLU_USERS = [
        UserAuthorities.SIKLU_ACCOUNTANT,
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.SIKLU_SALES
    ];
    public static readonly ALL_COMPANY = [UserAuthorities.COMPANY_ADMIN, UserAuthorities.COMPANY_PLANNER, UserAuthorities.COMPANY_USER];
    public static readonly PROJECT_ALL = [
        UserAuthorities.SIKLU_ADMIN,
        UserAuthorities.SIKLU_ACCOUNTANT,
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.SIKLU_SALES,
        UserAuthorities.COMPANY_ADMIN,
        UserAuthorities.COMPANY_PLANNER,
        UserAuthorities.COMPANY_USER
    ];
    public static readonly PROJECT_EDIT = [
        UserAuthorities.SIKLU_ACCOUNTANT,
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.COMPANY_ADMIN,
        UserAuthorities.COMPANY_PLANNER,
        UserAuthorities.SIKLU_SALES
    ];
    public static readonly PRODUCTS_EDIT = [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT];
    public static readonly PRODUCTS_VIEW = [
        UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
        UserAuthorities.SIKLU_SALES,
        UserAuthorities.COMPANY_ADMIN,
        UserAuthorities.COMPANY_PLANNER,
        UserAuthorities.COMPANY_USER
    ];
    public static readonly TOOLTIP_EDIT = [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT];
    public static readonly USER_MANUAL_EDIT = [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT];
}
